import { render, staticRenderFns } from "./IssuesTypesFormEdit.vue?vue&type=template&id=f0f2a480&scoped=true"
import script from "./IssuesTypesFormEdit.vue?vue&type=script&lang=js"
export * from "./IssuesTypesFormEdit.vue?vue&type=script&lang=js"
import style0 from "./IssuesTypesFormEdit.vue?vue&type=style&index=0&id=f0f2a480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f2a480",
  null
  
)

export default component.exports